import { DragEndEvent } from '@dnd-kit/core'
import { SortableContext, arrayMove, verticalListSortingStrategy } from '@dnd-kit/sortable'
import { giphyCharcoal } from '@giphy/colors'
import { useContext, useEffect, useMemo, useState } from 'react'
import { DraggableContext, IconComponent } from 'ui'
import { UGEContext } from '../../context'
import Trimmer from '../../trimmer'
import LayerActions from '../shared/layer-actions'
import { Subheading, Toolbar } from '../style'
import Layer from './layer'
import { Empty, Layers, List } from './style'

type Props = {
    className?: string
}

const UGELayersEditor = ({ className }: Props) => {
    const { activeEditorProps, layers, resetEditorProps, setLayers } = useContext(UGEContext)
    const [activeLayerId, setActiveLayerId] = useState<string | undefined>()
    const reversedLayers = useMemo(() => [...layers].reverse(), [layers])

    function onDragEnd(e: DragEndEvent) {
        const { active, over } = e

        if (over?.id && active.id !== over.id) {
            const oldIndex = layers.findIndex((layer) => layer.id === active.id)
            const newIndex = layers.findIndex((layer) => layer.id === over.id)

            setLayers(arrayMove(layers, oldIndex, newIndex))
        }
    }

    useEffect(() => {
        setActiveLayerId(activeEditorProps?.layerId)
        resetEditorProps()
    }, [activeEditorProps])

    return (
        <div className={className}>
            <Toolbar>
                <Trimmer />
            </Toolbar>
            <Layers>
                <Subheading>
                    <IconComponent color={giphyCharcoal} height={20} icon="layers" width={20} />
                    All Layers:
                </Subheading>
                {reversedLayers.length > 0 ? (
                    <DraggableContext activationConstraint={{ distance: 2 }} onDragEnd={onDragEnd}>
                        <SortableContext items={reversedLayers} strategy={verticalListSortingStrategy}>
                            <List>
                                {reversedLayers.map((layer) => (
                                    <Layer
                                        draggable={reversedLayers.length > 1}
                                        key={`uge-layer-list-${layer.id}`}
                                        layer={layer}
                                        open={layer.id === activeLayerId}
                                        onOpen={setActiveLayerId}
                                    >
                                        <LayerActions editor="layers" layer={layer} />
                                    </Layer>
                                ))}
                            </List>
                        </SortableContext>
                    </DraggableContext>
                ) : (
                    <Empty />
                )}
            </Layers>
        </div>
    )
}

export default UGELayersEditor
